export const HISTORY_FORM_FIELD_NAME_START_DATE = 'history-form-start-date'
export const HISTORY_FORM_FIELD_NAME_END_DATE = 'history-form-end-date'
export const HISTORY_FORM_FIELD_NAME_STATUS = 'history-form-status'
